import '../setupEnv'

import React from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import '../controllers/index.js'
import { Turbo } from '@hotwired/turbo-rails'
Turbo.session.drive = true

// Those can only be imported on client-side and will crash server-side
import OLMap from 'ol/Map'
import { defaults as OLdefaultControls } from 'ol/control'

// Needs to be imported here, otherwise things go horribly, horribly wrong, for reasons 🤷‍♂️
import 'react-infinite-calendar/styles.css'
import 'typeface-lato'
import 'ol/ol.css'
import '../globalStyles'

import App from '../App'

var componentRequireContext = require.context('pages', true)
var ReactRailsUJS = require('react_ujs')

global.OpenLayersClient = {
  Map: OLMap,
  defaultControls: OLdefaultControls
}

ReactRailsUJS.useContext(componentRequireContext)

const reactRoots = new Map()

ReactRailsUJS.mountComponents = function(searchSelector) {
  var ujs = ReactRailsUJS
  var nodes = ujs.findDOMNodes(searchSelector)

  for (var i = 0; i < nodes.length; ++i) {
    var node = nodes[i]
    var className = node.getAttribute(ujs.CLASS_NAME_ATTR)
    var PageComponent = ujs.getConstructor(className)
    var propsJson = node.getAttribute(ujs.PROPS_ATTR)
    var props = propsJson && JSON.parse(propsJson)
    var shouldHydrate = node.getAttribute(ujs.RENDER_ATTR)

    if (!PageComponent) {
      var message = "Cannot find component: '" + className + "'"
      throw new Error(
        message + '. Make sure your component is available to render.'
      )
    } else {
      const app = <App PageComponent={PageComponent} pageProps={props} />

      const existingRoot = reactRoots.get(node)
      if (existingRoot) {
        existingRoot.render(app)
      } else {
        if (shouldHydrate) {
          const root = hydrateRoot(node, app)
          reactRoots.set(node, root)
        } else {
          const root = createRoot(node)
          root.render(app)
          reactRoots.set(node, root)
        }
      }
    }
  }
}

ReactRailsUJS.unmountComponents = function() {
  reactRoots.forEach((root, node) => {
    if (!document.contains(node)) {
      root.unmount()
      reactRoots.delete(node)
    }
  })
}

document.addEventListener("turbo:before-render", (event) => {
  ReactRailsUJS.unmountComponents()
});

document.addEventListener("turbo:render", () => {
  ReactRailsUJS.mountComponents();
});

document.addEventListener('DOMContentLoaded', () => {
  ReactRailsUJS.mountComponents()
})

document.addEventListener('turbo:load', function() {
  document.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
    const originalOnLoad = link.onload;
    link.onload = () => {
      if (originalOnLoad) originalOnLoad();
    };
    const href = link.href;
    link.href = '';
    requestAnimationFrame(() => {
      link.href = href;
    });
  });
})
